import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import HomePageBox from "@Components/HomePageBox";
const HomePage = () => {
    return (_jsx(HomePageBox, {}));
};
export default HomePage;
